import axios from "axios";

export const analyze = (formData, callback) => {
  var promise = axios({
    method: 'POST',
    url: Routes.analyze_documents_path({ 'format': 'json' }),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token
    }
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error);
    });
}
